module.exports = __webpack_public_path__ + "static/media/down-carrot-white.7cc98607.svg";